import { ExclamationCircleOutlined, SyncOutlined } from "@ant-design/icons";
import { Tag } from "antd";
import { useTranslation } from "react-i18next";
import { useSaving } from "../hooks/useSaving.tsx";
import { clickable } from "../styles/shared.styles.ts";
import { type ReactNode } from "react";

export const SavingIndicator = ({ children = null }: { readonly children?: ReactNode }) => {
  const { t } = useTranslation();
  const { saving, error, retry } = useSaving();

  if (error) {
    return (
      <Tag className={clickable} color="error" icon={<ExclamationCircleOutlined />} onClick={retry}>
        {t("g.savingError")}
      </Tag>
    );
  }

  if (!saving) return children;

  return (
    <Tag color="processing" icon={<SyncOutlined spin />}>
      {t("g.saving")}
    </Tag>
  );
};
